import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";
import {
	DragTrComponent,
	DropTbodyComponent
} from "components/DigiHapi/DraggableTable";
import { DragDropContext } from "react-beautiful-dnd";

// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import Notification from "components/DigiHapi/Notification";

import { GiBarracksTent } from "react-icons/gi";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchGetLocations, fetchReorderLocations } from "actions/location";

import { LOCATIONS_ON_DRAG_END } from "actions/types.js";

class LocationsOrderPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null
	};

	getLocations = () => {
		const { fetchGetLocations, community } = this.props;
		fetchGetLocations(community._id);
	};

	componentDidMount() {
		this.getLocations();
	}

	componentDidUpdate(prevProps, prevState) {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.getLocations();
			this.autoCloseMessage();
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	getLocationsData = () => {
		const { locations } = this.props;

		const locationsObj = locations.map(({ _id, name }) => {
			return {
				_id,
				name
			};
		});
		return locationsObj;
	};

	handleDragEnd = result => {
		this.props.dispatch({
			type: LOCATIONS_ON_DRAG_END,
			result
		});
	};

	render() {
		const { color, message } = this.state;
		const {
			isFetching,
			isFetchingList,
			locations,
			areLocationsReordered,
			fetchReorderLocations
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<GiBarracksTent size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								Réorganiser les hébergements
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							{locations.length > 0 && (
								<DragDropContext onDragEnd={this.handleDragEnd}>
									<MDBox
										sx={{ maxHeight: "calc(100vh - 400px)", overflow: "auto" }}
									>
										<DataTable
											TrComponent={DragTrComponent}
											TbodyComponent={DropTbodyComponent}
											data={this.getLocationsData()}
											filterable
											columns={[
												{
													Header: "Nom",
													accessor: "name",
													sortable: false,
													filterable: false
												},
												{
													Header: "",
													accessor: "empty",
													sortable: false,
													filterable: false
												}
											]}
											loading={isFetchingList}
											defaultPageSize={locations.length}
											showPaginationTop={false}
											showPaginationBottom={false}
											noDataText="Aucuns hébergements"
											loadingText="Chargement..."
										/>
									</MDBox>
								</DragDropContext>
							)}
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							<MDButton
								variant="outlined"
								color="secondary"
								disabled={!areLocationsReordered}
								onClick={this.getLocations}
							>
								{"Restaurer"}
							</MDButton>
							<MDButton
								variant="gradient"
								color="primary"
								disabled={!areLocationsReordered}
								onClick={() => fetchReorderLocations(locations)}
							>
								{isFetching ? (
									<CircularProgress size={16} color="inherit" />
								) : (
									"Réorganiser"
								)}
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		snackInfoMsg,
		snackErrorMsg,
		locations,
		areLocationsReordered
	} = state.locationReducer;

	const { community } = state.entitiesReducer;

	return {
		isFetchingList,
		isFetching,
		locations: Object.values(locations),
		snackInfoMsg,
		snackErrorMsg,
		areLocationsReordered,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetLocations,
			fetchReorderLocations
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationsOrderPage);
